import {combineReducers} from 'redux';

import create from './document-create/reducer';
import edit from './document-instance/document-edit/reducer';
import index from './documents-index/reducer';
import instance from './document-instance/reducer';

export default combineReducers({index, create, instance, edit});
